import React from 'react'
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import { connect } from 'react-redux'

import { getCountriesWithCities } from '../selectors'
import { mainCountries, otherCountries } from '../../lib/countries.js'
import { l } from '../../lib/Tools.js'
import { getText } from '../lib/text.js'

type CSProps = {
  value: string, 
  onChange: string => void, 
  labelWidth: ?number, 
  disabled: ?boolean,
  label: ?string,
}

const CountrySelector = (
  { value, onChange, countries, onlyCountriesWithCities, labelWidth, disabled, label }
  : CSProps
) => (
  <FormGroup>
    <ControlLabel            
      style={labelWidth ? { width: labelWidth } : {}}
    >
      {label || getText("País")}
    </ControlLabel>
    <FormControl
      componentClass="select"
      value={value}
      onChange={evt => onChange(evt.target.value)}
      disabled={disabled}
    >
      {
        countries.map(country => (
          <option key={country.name} value={country.name}>
            {country.flag}  {getText(country.name)}
          </option>
        ))
      }
    </FormControl>
  </FormGroup>
)

const mapStateToProps = (state, props) => {
  if (props.onlyCountriesWithCities) {
    const cwc = getCountriesWithCities(state, props)
    const countries = [...cwc.mainCountries, ...cwc.otherCountries]
    return { countries }
  }
  else {
    return { countries: [...mainCountries, ...otherCountries] }
  }
}

const mapDispatchToProps = () => ({})

export default connect(
  mapStateToProps, mapDispatchToProps
)(CountrySelector)
